module.exports = __webpack_public_path__ + "site/img/59.f74c358d.jpg";